var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "modal-footer" }, [
    _c(
      "div",
      { staticClass: "modal-footer-group group-left" },
      [
        _vm._t("group-left", function () {
          return [
            _c(
              "b-button",
              {
                staticClass: "btn-default",
                attrs: { text: "Close" },
                on: { click: _setup.modal.dismiss },
              },
              [_vm._v("\n        Close\n      ")]
            ),
          ]
        }),
      ],
      2
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "modal-footer-group group-right" },
      [_vm._t("group-right")],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }